export enum RolModulePermissionEnum {
  // RESELLER
  CreateReseller = 'crear-reseller',
  EditReseller = 'editar-reseller',

  // ACCOUNT
  ActivateAccount = 'activar-account',
  DeactivateAccount = 'desactivar-account',
  CreateAccount = 'crear-account',
  EditAccount = 'editar-account',

  // ROLE
  CreateRole = 'crear-rol',
  EditRole = 'editar-rol',
  DeleteRole = 'eliminar-rol',

  // USER
  ActivateUser = 'activar-usuario',
  DeactivateUser = 'desactivar-usuario',
  CreateUser = 'crear-usuario',
  EditUser = 'editar-usuario',
  
  // STORE
  CreateStore = 'crear-tienda',
  EditStore = 'editar-tienda',
  ActivateStore = 'activar-tienda',
  DeactivateStore = 'desactivar-tienda',
  
  // LICENSE
  DeleteLicenses = 'eliminar-licencias',
  AddLicenses = 'agregar-licencias',
  EditLicenses = 'editar-licencias',
  
  // APK
  CreateApk = 'crear-apk',
  EditApk = 'editar-apk',
  DeleteApk = 'eliminar-apk',
}